
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sitemap/[[...page]]",
      function () {
        return require("private-next-pages/sitemap/[[...page]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sitemap/[[...page]]"])
      });
    }
  